'use es6';

import { getDefinition } from 'FormsUI/selectors/FormDefinition';
const getSelectedExternalOptions = state => getDefinition(state).selectedExternalOptions || [];
export default getSelectedExternalOptions;